import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import AccountAreaComponent from "../../../authentication/account_area/account_area.component";
import mediLogo from "./medi.png";
import { useTranslation } from "react-i18next";
import { HeaderArea } from "./header.style";

export const HeaderComponent = () => {
  const { t } = useTranslation();

  return (
    <HeaderArea>
      <div>
        <Container>
          <Stack direction="row" alignItems="center" my={2.5}>
            <img src={mediLogo} alt="medi logo" style={{ marginRight: 16 }} />
            <Typography variant="h6" fontWeight="bold">
              {t("MDS_AppName")}
            </Typography>
            <Box sx={{ ml: "auto" }}>
              <AccountAreaComponent />
            </Box>
          </Stack>
        </Container>
      </div>
    </HeaderArea>
  );
};
